import React                   from 'react';
import { connect }             from 'react-redux';
import { reducerType }         from 'reducer';
import { Dispatch }            from "redux";
import { ActionTypes }         from 'actions/types';
import BigProgressBar          from 'components/progressBars/BigProgressBar';
import SmallProgressBar        from 'components/progressBars/ProgressBar';
import Question                from './Question';
import { 
    pages,
    getPage,
    autoPageChange 
}                              from './pages';
import Menu                    from 'components/menu';
import Modal                   from 'components/modal';
import InputQuestion           from './inputQuestion';
import DndQuestion             from './dndQuestion';
import handleNavigate          from 'functions/handleNavigate';
import openModal               from 'functions/modal/openModal';
import { 
    componentsStateType, 
    modalStateType 
}                              from 'reducer/types';
import { makeStyles }          from "makeStyles";
import closeModal              from 'functions/modal/closeModal';


const useStyles = makeStyles()(
    (Theme) => ({
        root : {
            position:       'fixed',
            left:           0,
            minHeight:      '100vh',
            maxHeight:      '100vh',
            display:        'flex',
            flexFlow:       'column',
            alignItems:     'center',
            justifyContent: 'center',
            transition:     'opacity 0.25s'
        },
        container: {
            width:          '100%',
            display:        'flex',
            alignItems:     'center',
        },
        title: {

            height:         45,
            display:        'flex',
            alignItems:     'center',
            justifyContent: 'center',
            color:          Theme.darkBlue,
            fontSize:       Theme.normalFont
          },
    }),
);

type MazegetPropsType = {
    size:            number[];
    menuSize:        number;
    wideScreen:      boolean;
    componentsState: componentsStateType;
    modalState:      modalStateType;
}

const Mazeget: React.FC<MazegetPropsType> = ({
    size,
    menuSize,
    wideScreen,
    componentsState,
    modalState
}) => {

    const { classes } = useStyles();

    const [pageNum, setPageNum]                 = React.useState(0)
    const [opacity, setOpacity]                 = React.useState(1)
    const [questionVariant, setQuestionVariant] = React.useState('input')

    const nextPage = React.useCallback(() => {


        if (pageNum >= getPage('dragUnits1')) {
            handleNavigate('tirgul')
            return
        }
        
        if (pageNum === getPage('markExpandButton')) {
            openModal('showTensMazeget') 
        }
      
        if (pageNum === getPage('typeInput2')) {
           // closeModal();
            setOpacity(0);
            setTimeout(() => { 
                setOpacity(1) 
                setPageNum(pageNum + 1)
                setQuestionVariant('dnd')
            },400)
        }
        else {
            setPageNum(pageNum + 1)
        }

    },[pageNum])


    React.useEffect(() => {

      if (pageNum === getPage('dragTen0')) {
          setTimeout(() => {
            nextPage()
          },2000)
          return;
      }

      if (autoPageChange.includes(pageNum)) {
          setTimeout(() => {
            nextPage()
          },1000)
      }
    },[pageNum, nextPage])


    React.useEffect(() => {
        if (pageNum > getPage('openModal') && pageNum <= getPage('openModal') + 1) {
            closeModal()
        }
      },[pageNum])


    
    

    const [rootStyle, containerStyle] = React.useMemo(() => {
        return[
            { 
               width:   size[0] - menuSize,
               opacity: componentsState.animateComp ? 0 : opacity
            },
            {
               flexFlow:       wideScreen ? 'row' : 'column',
               justifyContent: wideScreen ? 'center' : 'flex-end',
               flex:           wideScreen ? 0.4 : 0.2,
            }
        ]
     },[size, menuSize, wideScreen, opacity, componentsState])


     const [wscreen, setWscreen] = React.useState(wideScreen);

     React.useEffect(() => {
             if ( wscreen !== wideScreen ) {
                setWscreen(wideScreen)
                setPageNum(0)
                setQuestionVariant('input')
             }
         },[wideScreen, wscreen])   

    return(
<>
        {
            wideScreen &&
            <BigProgressBar
               size     = { size }     
               menuSize = { menuSize } 
               length   = { pages.length - 1 }   
               prog     = { pageNum }     
            />
        }
        {
            !wideScreen &&
            <SmallProgressBar
               length   = { pages.length - 1 }   
               testNum  = { pageNum }     
            />
        }
        <div 
           className = { classes.root }
           style     = { rootStyle }
        >
            {
                
                <>
                   <Question
                       size       = { size }
                       question   = { 37 }
                       pageNum    = { pageNum }
                       variant    = { questionVariant }
                       wideScreen = { wideScreen }
                   />
                   
                    <div 
                       className = { classes.container }
                       style     = { containerStyle }
                    >
                        
                        {
                            questionVariant === 'dnd' &&
                            <DndQuestion 
                               size           = { size }
                               pageNum        = { pageNum }
                               wideScreen     = { wideScreen }
                               feedBack       = { '' }
                               question       = { 37 }
                               nextPage       = { nextPage }
                            />
                        }
                        {
                            questionVariant === 'input' &&
                            <InputQuestion
                               question       = { 37 }
                               pageNum        = { pageNum }
                               nextPage       = { nextPage }
                            />
                        }
                       
                    </div>
                </>
            }
        </div>
        <Menu
          level         = { -1 }
          menuSize      = { menuSize } 
          wideScreen    = { wideScreen }
          goToNextTest  = { () => {} }
          goToNextLevel = { () => {} }
        />
        {
          modalState.showModal &&
          <Modal 
            size     = { size }
            question = { 37 }
          />
        }
        {/* <Modal 
           size     = { size }
           question = { 37 }
        /> */}
      </>






    )
}


  

  const mapStateToProps = (reducer: reducerType) => {
    return {
      componentsState: reducer.components,
      modalState:      reducer.modal
  }};
    
  const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  });
    
  export default connect(mapStateToProps,mapDispatchToProps)(Mazeget);
    
    
    
    
    

